import cx from 'classnames'

import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'

import { Join } from '../../../../constants'
import { Button } from 'components/Button'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { ReactComponent as Chevron } from 'assets/icons/chevron-down__12.svg'

import Styles from './JoinButton.module.scss'

interface Props {
  glue: Join
  isWhere: boolean
  isButton: boolean
  onSelect: (glue: Join) => void
  isDisabled?: boolean
}

export const JoinButton = ({ glue, isWhere, isButton, onSelect, isDisabled = false }: Props) => {
  if (isWhere) return <p className={cx(Styles.joinButtonParagraph, { [Styles.disabled]: isDisabled })}>Where</p>

  if (isButton) {
    return (
      <DropdownTrigger popoverClassName={Styles.joinButtonPopover}>
        <Button className={Styles.joinButton} variant="secondaryGrey" isDisabled={isDisabled}>
          <span>{glue}</span>
          <Chevron className={Styles.chevron} />
        </Button>
        {(close) => (
          <div className={Styles.joinButtonDropdown}>
            <Menu
              selectionMode="single"
              onSelectionChange={(value) => {
                onSelect((value as Set<Join>).values().next().value as Join)
                close()
              }}
              selectedKeys={new Set([glue])}
              aria-label="Menu"
            >
              {Object.values(Join).map((join, index) => (
                <Item key={join} textValue={join}>
                  {join}
                </Item>
              ))}
            </Menu>
          </div>
        )}
      </DropdownTrigger>
    )
  }

  return <p className={cx(Styles.joinButtonParagraph, { [Styles.disabled]: isDisabled })}>{glue}</p>
}
